<script setup>
import Button from '@components/forms/Button.vue'

const props = defineProps({
	title: {
		type: String,
		required: false,
	},
	description: {
		type: String,
		required: false,
	},
	logo: {
		type: String,
		required: false,
	},
	poster: {
		type: String,
		required: false,
	},
	externalLabel: {
		type: String,
		required: false,
	},
	externalUrl: {
		type: String,
		required: false,
	},
})
</script>

<template>
	<section class="mb-10">
		<div class="container">
			<div class="overflow-hidden rounded-lg bg-snk-dark-500">
				<img class="h-full w-full object-cover lg:object-top-right" :src="poster" :alt="title" v-if="poster" />

				<div class="grid-cols-3 gap-5 p-5 text-snk-light-500 md:grid md:p-8">
					<!-- <div class="flex items-center justify-center p-3 lg:px-10" v-if="logo">
						<img class="max-h-20 md:max-h-40" :src="logo" :alt="title" />
					</div> -->
					<div class="col-span-2 flex flex-col justify-center gap-5">
						<!-- <div class="flex flex-wrap gap-2">
							<Tag class="primary">{{ event.game?.name_short ?? event.game?.name }}</Tag>
							<!-- <Tag class="primary">SNK</Tag>
						</div> -->
						<div class="h5">{{ title }}</div>
						<p class="text-sm">{{ description }}</p>
						<Button iconRight="far fa-arrow-up-right-from-square" class="solid primary wide thin md:hidden" :href="externalUrl" v-if="externalLabel && externalUrl">{{ externalLabel }}</Button>
						<Button iconRight="far fa-arrow-up-right-from-square" class="solid primary hidden md:block" :href="externalUrl" v-if="externalLabel && externalUrl">{{ externalLabel }}</Button>
					</div>
					<!-- <div class="flex h-full flex-col justify-end">
							<p class="opacity-75">The stage is set! The SNK World Championship 2025 unites top players from around the globe to battle it out for ultimate glory in SNK’s legendary titles.</p>
						</div> -->
				</div>
			</div>
		</div>
	</section>
</template>
